// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-form ion-list {
  max-height: 210px;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/core/components/due-date-picker/due-date-picker.component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,gBAAA;AAAJ","sourcesContent":[".input-form {\n  ion-list {\n    max-height: 210px;\n    overflow-y: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
